import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCloseThin = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m1 1 35.355 35.355m0-35.355L1 36.355"
      stroke="#FFF"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgCloseThin);
export default Memo;
